import {gsap} from "gsap";
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {imageLazyLoading} from "../../scripts/functions/imageLazyLoading";
import {animations} from "../../scripts/general/animations";
import './index.html';
import './style.scss';

gsap.registerPlugin(ScrollTrigger);
export default async (block) => {
  gsap.defaults({ease: "none"})
  const logoAndTitle = block.querySelector(".logo-and-title")
  const schoolMissionStatement = block.querySelector(".school-mission-statement")
  const arrow = block.querySelector(".arrow")
  // document.body.style.height = '100vh';
  // document.body.style.overflow = 'hidden';
  // window.scrollTo(0, 0);
  const tl = gsap.timeline({
    paused: true,
    onComplete() {
      // block.classList.add('last-step');
      // document.body.style.height = 'auto';
      // document.body.style.overflow = 'auto';
      // document.body.style.overflowX = 'hidden';
      final();
    }
  })
  .from(logoAndTitle, {opacity: 0})

  .to(logoAndTitle, {opacity: 0}, '+=1')
  .from(schoolMissionStatement, {opacity: 0})
  .from(arrow, {
    opacity: 0,
    onComplete: () => arrow.classList.add('active'),
  })
  .timeScale(.7)
  function arrowAnimation() {
    block.querySelector(".arrow").classList.add('active')
  }

  // let scrolled = false;
  // window.addEventListener('scroll',)


  // let heroAnimation = gsap.timeline({
  //   defaults: {duration: 1, ease: "back"},
  //   onComplete() {
  //     // block.classList.add('last-step');
  //     document.body.style.height = 'auto';
  //     document.body.style.overflow = 'auto';
  //     document.body.style.overflowX = 'hidden';
  //     final();
  //   }
  // })
  //   .from(block.querySelector(".logo-and-title img"), {
  //     scale: 0,
  //     rotate: 45,
  //     delay: .5
  //   })
  //   .from(block.querySelector(".headline-1"), {
  //     yPercent: 100,
  //     opacity: 0,
  //   }, "<-.10")
  //   .to(block.querySelector(".logo-and-title img"), {
  //     yPercent: -100,
  //     opacity: 0
  //   }, '+=1')
  //   .to(block.querySelector(".headline-1"), {
  //     yPercent: -100,
  //     opacity: 0
  //   }, "<-.10")
  //   .from(block.querySelectorAll(".school-mission-statement *"), {
  //     y: 100, opacity: 0, stagger: .05
  //   })
  //   .from(block.querySelector(".arrow"), {
  //     y: -500, opacity: 0, duration: 1
  //   }, ">")
  //   .add(arrowAnimation)
  //
  // function heroStyle() {
  //   block.classList.add('last-step')
  // }





  function final() {
    const nextBlock = block.nextElementSibling;
    arrow?.classList.add('animation-completed');
    if (nextBlock.tagName === 'SECTION') {
      arrow?.addEventListener('click', () => {
        window.scrollTo({
          top: window.scrollY + nextBlock.getBoundingClientRect().top - 100,
          behavior: 'smooth'
        })
      })
    }
  }

  setTimeout(() => tl.play(), 1500)
  animations(block);
  imageLazyLoading(block);
};

